<template>
  <v-card class="thumbnail-card">
    <a
      :href="thumbnailObject && thumbnailObject.originalFileUrl"
      :download="thumbnailObject && thumbnailObject.filename"
      :class="{'thumbnail-card__not-allowed' : !thumbnailObject}"
      target="_blank"
    >
      <div
        class="thumbnail-card__image-container"
        :style="thumbnailObject && `background-image: url(${thumbnailObject.url})`"
      >
        <img
          v-if="!thumbnailObject || !thumbnailObject.url"
          src="@/assets/img/img-blank.svg"
        >
      </div>
    </a>
  </v-card>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      default: () => {},
    },
    youtube: {
      type: [String, null],
      default: ''
    },
  },
  computed: {
    thumbnailObject() {
      return this.youtube ? { url: this.youtube } : this.image
    }
  }
};
</script>

<style lang="scss" scoped>
.thumbnail-card {
  padding: 32px;

  &__image-container {
    background-color: $secondary;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  &__not-allowed {
    cursor: default;
  }
}
</style>
